export function generateZoneLabelList(allLabels: string[]) {
  const namesRegister = [...allLabels];
  allLabels.forEach((label, i) => {
    if (!!label) return;
    namesRegister[i] = generateZoneLabel(namesRegister);
  });
  return namesRegister;
}

export function generateZoneLabel(names: string[]): string {
  const name = "Zone";
  let index = 1;
  while (names.includes(`${name} ${index}`)) {
    index++;
  }
  return `${name} ${index}`;
}
